/**
 * Legacy JavaScript entry point for Rspack.
 *
 * This file replaces the former Sprockets `application.js` manifest.
 * The `app/assets/javascripts/` directory has been fully removed.
 */

// --- Core libraries ---
// jQuery must be imported first and exposed globally BEFORE any plugin that
// checks window.jQuery at evaluation time (e.g. imagesloaded, flickity).
import "jquery";
import "../lib/jquery_globals"; // window.$ = window.jQuery = $

import "jquery-ujs";
import "jquery-ui/dist/jquery-ui";

// --- Bootstrap ---
import "bootstrap/dist/js/bootstrap";

// --- Tear down Bootstrap 3 plugins replaced by vanilla modules ---
// Our custom vanilla modules handle the renamed data attributes;
// Bootstrap's listeners would conflict if left active.
$(document).off(".bs.dropdown.data-api");
$(document).off(".bs.collapse.data-api");
$(document).off(".bs.tab.data-api");
$(document).off(".bs.tooltip.data-api");
// Note: NOT overriding $.fn.tooltip — Summernote uses it internally for button tooltips
$(document).off(".bs.modal.data-api");

// --- Vanilla replacements for Bootstrap JS components ---
import "../lib/dropdown";
import "../lib/collapse";
import "../lib/tab";
import "../lib/tooltip";
import "../lib/modal";

// --- Confirm modal (vanilla replacement for data-confirm-modal npm package) ---
import "../lib/confirm";

// --- Past-arrival summary notice auto-dismiss (5s) ---
import "../lib/past_arrival_notice";

// --- Admin sidebar (event delegation + modal blur + intercom triggers) ---
import "../lib/admin_sidebar";

// --- Booking details opener (eventbus → sidepanel ajax bridge) ---
import "../lib/booking_details_opener";

// --- Summernote WYSIWYG editor (pinned: 0.8.10, matching summernote-rails gem) ---
import "summernote/dist/summernote-bs4";
import "../legacy/app/summernote-init";

// --- jQuery file upload (pinned: blueimp 9.12.5, matching jquery-fileupload-rails gem) ---
// Sprockets `jquery-fileupload/basic` loaded: jquery.ui.widget (already in jquery-ui),
// jquery.iframe-transport, and jquery.fileupload.
import "blueimp-file-upload/js/jquery.iframe-transport";
import "blueimp-file-upload";

// --- Cloudinary jQuery SDK (extracted from cloudinary gem v2.4.0, JS v2.5.0) ---
// Using gem-extracted file to avoid version conflicts with pre-existing
// cloudinary-jquery@^2.14.0 used by other Rspack entries.
import "../legacy/vendor/cloudinary/jquery.cloudinary";

// --- Cocoon (nested forms, extracted from cocoon gem v1.2.15) ---
// Using gem-extracted file instead of unreliable cocoon-js npm package.
import "../legacy/vendor/cocoon";

// --- Attachinary (custom fork - extracted from gem) ---
import "../legacy/app/attachinary";
import "../legacy/app/init_attachinary";

// --- Underscore (pinned: 1.13.7) ---
// Must be on window._ for gmaps_google.js which uses bare _ references.
import _ from "underscore";
window._ = _;

// --- Gmaps4Rails (extracted from gem) ---
import "../legacy/vendor/gmaps_google";

// --- Bootstrap datepicker ---
import "bootstrap-datepicker";

// --- Bootstrap toggle ---
import "bootstrap-toggle";

// --- Simple form custom inputs (extracted from gem) ---
// ezdz.js is a dependency required by simple_form_custom_inputs via Sprockets
// directive `//= require ./ezdz`. Must be loaded before simple_form_custom_inputs.
import "../legacy/vendor/ezdz";
import "../legacy/vendor/simple_form_custom_inputs";

// --- Moment locales ---
// moment is globally provided via ProvidePlugin; import locales for side effects.
// Expose on window for inline scripts that access window.moment.
import moment from "moment";
window.moment = moment;
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/it";
import "moment/locale/de";
import "moment/locale/zh-cn";
import "moment/locale/ru";
import "moment/locale/pt";
import "moment/locale/nl";
import "moment/locale/ca";
import "moment/locale/hr";
import "moment/locale/el";
import "moment/locale/pl";

// --- Fullcalendar (pinned: 3.9.0, matching fullcalendar-rails gem) ---
import "fullcalendar";
import "fullcalendar/dist/locale-all";

// --- jQuery plugins ---
import "slick-carousel";
import "jquery.maskedinput/src/jquery.maskedinput";

// --- jQuery Minicolors (extracted from jquery-minicolors-rails gem v2.2.6) ---
// npm only has up to 2.1.10; gem bundles 2.2.6, so we use the gem file.
import "../legacy/vendor/jquery.minicolors";
import "../legacy/vendor/jquery.minicolors.simple_form";

// --- Cropper (pinned: 2.3.2, matching cropper-rails gem) ---
// NOTE: this is the OLD `cropper` package (jQuery plugin), NOT `cropperjs`.
import "cropper";

// --- Chartkick + Chart.js (pinned: chartkick 4.2.0 + chart.js 3.9.1) ---
// Matches chartkick gem 4.2.0. Chart.js 3.x with /auto registers all components,
// equivalent to the gem's Chart.bundle.js.
import Chart from "chart.js/auto";
import Chartkick from "chartkick";
Chartkick.use(Chart);
window.Chartkick = Chartkick;

// --- Spectrum colorpicker (pinned: 1.8.1, matching spectrum-rails gem) ---
// NOTE: this is the ORIGINAL `spectrum-colorpicker`, NOT the `spectrum-colorpicker2` fork.
import "spectrum-colorpicker";

// --- Flickity carousel (pinned: 2.1.2 + fullscreen 1.1.0, matching vendored files) ---
import "flickity";
import "flickity-fullscreen";

// --- Other vendor libs ---
import "aos";
import "imagesloaded";
import "fittext.js";
import "../legacy/vendor/jquery.textfill"; // vendored v0.6.2 (npm only has 0.6.0)
import "jsencrypt"; // pinned: 3.0.0-beta.1, matching vendored file
import "perfect-scrollbar"; // pinned: 0.6.15, matching vendored file
// --- Vendor libs without npm equivalents (copied into repo) ---
import "masonry-layout"; // pinned: 4.2.2, matching vendored file
import "../legacy/vendor/sortable";
import "../legacy/vendor/loading-bar";
import "../legacy/vendor/latinize";
import "../legacy/vendor/lazyload";

// --- Application dependencies (custom Amenitiz code) ---
import "../legacy/dependencies/jquery.daterangepicker";
import "../legacy/dependencies/config_datepicker";
import "../legacy/dependencies/site_calendar";
import "../legacy/dependencies/amenitiz";

// --- Application logic (custom code) ---
import "../legacy/app/flash";
import "../legacy/app/tables";
import "../legacy/app/sidepanel";
import "../legacy/app/sidepanel_scrim";
import "../legacy/app/add_reservation";
import "../legacy/app/booking_details_sidepanel";
import "../legacy/app/picture-library";
import "../legacy/app/promotion_form_new";

// --- Password toggle ---
import "../legacy/app/password_toggle";

// --- Summernote locales ---
import "../legacy/app/summernote-fr-FR";
import "../legacy/app/summernote-es-ES";

// --- Inline code from original application.js ---

$.minicolors.defaults = $.extend($.minicolors.defaults, {
  keywords: "transparent",
});

// JS to fadeout the alert in the admin
window.setTimeout(() => {
  $(".alert").delay(2000).fadeOut(3000);
});

$('[data-provider="summernote"]').each(function () {
  $(this).summernote({
    height: 200,
    tabsize: 2,
    toolbar: [
      ["style", ["bold", "italic", "underline", "clear"]],
      ["para", ["ul", "ol"]],
      ["link", ["link"]],
      ["view", ["codeview"]],
    ],
    callbacks: {
      // Clear all formatting of the pasted text
      onPaste(e) {
        const bufferText = (
          (e.originalEvent || e).clipboardData || window.clipboardData
        ).getData("Text");
        e.preventDefault();
        setTimeout(() => {
          document.execCommand("insertText", false, bufferText);
        }, 10);
      },
    },
  });
});

window.fillBlankWithDots = function fillBlankWithDots() {
  const inputsForDots = document.getElementsByClassName("dot-blank");
  for (let i = 0; i < inputsForDots.length; i++) {
    if (inputsForDots[i].textContent === "") {
      inputsForDots[i].textContent = ".........";
    }
  }
};

$.htmlPrefilter = (html) => html;
